import { createContext } from "react";
/**
 * For passing down variables that are set using process.env
 *
 * This is set in the platform-host-app and will be consumed in the side-loaded apps.
 * This is used over AppContext as that is stored in local storage.
 */
export const AppEnvironmentContext = createContext(undefined);
export const AppEnvironmentContextProvider = AppEnvironmentContext.Provider;
